const actions = {
  countFilter: ({ commit }, payload) => {
    let filterCount = 0
    console.log(payload);
    if (payload.periode) {
      filterCount ++
    }
    if (payload.rekeningAtasNama.length) {
      filterCount ++
    }
    if (payload.mesinEdc.length) {
      filterCount ++
    }
    if (payload.idKaryawan) {
      filterCount ++
    }
    commit("upDateFilterCount", filterCount);
  },
};

export default actions;
